// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"133":"004be368","190":"5e51e516","208":"dc0bce3e","246":"2d48cb5f","439":"cc775789","510":"0d522353","540":"2e52bff4","716":"03b56e03","971":"93731d19"}[chunkId] + ".chunk.js";
};